var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircularActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    rx: 5,
    fill: "#7E6ECC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 8.75C16.3151 8.75 15.1826 8.98242 14.1025 9.44727C13.0225 9.91211 12.0928 10.5342 11.3135 11.3135C10.5342 12.0928 9.91211 13.0225 9.44727 14.1025C8.98242 15.1826 8.75 16.3151 8.75 17.5C8.75 18.6849 8.98242 19.8174 9.44727 20.8975C9.91211 21.9775 10.5342 22.9072 11.3135 23.6865C12.0928 24.4658 13.0225 25.0879 14.1025 25.5527C15.1826 26.0176 16.3151 26.25 17.5 26.25C18.6849 26.25 19.8174 26.0176 20.8975 25.5527C21.9775 25.0879 22.9072 24.4658 23.6865 23.6865C24.4658 22.9072 25.0879 21.9775 25.5527 20.8975C26.0176 19.8174 26.25 18.6849 26.25 17.5C26.25 16.3151 26.0176 15.1826 25.5527 14.1025C25.0879 13.0225 24.4658 12.0928 23.6865 11.3135C22.9072 10.5342 21.9775 9.91211 20.8975 9.44727C19.8174 8.98242 18.6849 8.75 17.5 8.75ZM28 17.5C28 19.4049 27.5306 21.1618 26.5918 22.7705C25.653 24.3792 24.3792 25.653 22.7705 26.5918C21.1618 27.5306 19.4049 28 17.5 28C15.5951 28 13.8382 27.5306 12.2295 26.5918C10.6208 25.653 9.34701 24.3792 8.4082 22.7705C7.4694 21.1618 7 19.4049 7 17.5C7 15.5951 7.4694 13.8382 8.4082 12.2295C9.34701 10.6208 10.6208 9.34701 12.2295 8.4082C13.8382 7.4694 15.5951 7 17.5 7C19.4049 7 21.1618 7.4694 22.7705 8.4082C24.3792 9.34701 25.653 10.6208 26.5918 12.2295C27.5306 13.8382 28 15.5951 28 17.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircularActive);
export default __webpack_public_path__ + "static/media/Circular_Active.3c276816738c1024cfbde3cd1afbb65f.svg";
export { ForwardRef as ReactComponent };